/**
 * OWNER-OPERATING-SYSTEM-V1 honest-seam chip (the polish layer s.25.8; SEAM
 * law + DENSITY rule 6). A not-yet-real fact renders as this chip: a dashed
 * RING GLYPH (CSS-drawn, never a letter) leading a short human label, with
 * the one-line explainer riding the native tooltip (the build's popover
 * promotion is a routed follow-up -- NODOC keeps teaching off the surface).
 *
 * STRUCTURALLY UNTAPPABLE: renders a <span> with no handler and no href --
 * the SEAM law's "text, never a tappable control" is the component's shape,
 * not a convention. Never renders a fake zero; the label states the honest
 * state in user words ("Not tracked yet", "Mapping pending").
 */

export interface SeamChipProps {
  readonly label: string;
  /** One-line WHY explainer (native tooltip; popover promotion later). */
  readonly explainer?: string;
  readonly testId?: string;
}

export default function SeamChip({
  label,
  explainer,
  testId,
}: SeamChipProps): JSX.Element {
  return (
    <span className="ac-seamchip" title={explainer} data-testid={testId}>
      {label}
    </span>
  );
}
